import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'ps-levels',
  templateUrl: './levels.component.html',
  styleUrls: ['./levels.component.scss']
})
export class LevelsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
